import * as React from "react";
const SvgFiRrPersonCircleQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-person-circle-question_svg__a)">
      <path
        fill="#062147"
        d="M17 10c-3.86 0-7 3.141-7 7s3.14 7 7 7 7-3.141 7-7-3.14-7-7-7m1 11.899V21a1 1 0 1 0-2 0v.899A5.01 5.01 0 0 1 12 17c0-2.757 2.243-5 5-5s5 2.243 5 5a5.01 5.01 0 0 1-4 4.899m1.953-6.435c.223 1.272-.403 2.507-1.506 3.164-.733.437-1.447.371-1.447.371a1 1 0 1 1 0-2s.251 0 .481-.123a1 1 0 0 0 .502-1.066 1 1 0 0 0-.793-.793 1 1 0 0 0-1.057.483 1 1 0 1 1-1.73-1.002 2.98 2.98 0 0 1 3.133-1.451 3.02 3.02 0 0 1 2.417 2.417M2.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M10 13v-3c0-2.206-1.794-4-4-4H4c-2.206 0-4 1.794-4 4v3a4 4 0 0 0 2 3.463V23a1 1 0 1 0 2 0v-6h2v6a1 1 0 1 0 2 0v-6.537A4 4 0 0 0 10 13m-2 0c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2v-3c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-person-circle-question_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPersonCircleQuestion;
